import { SVGProps } from 'react'

const RatingIllustration = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="128"
      height="48"
      viewBox="0 0 128 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.1694 44.4637C15.1289 45.1447 13.2191 45.3804 11.2964 44.6339C9.83131 44.0577 8.09167 42.5386 7.69922 41.491C7.97391 41.4518 8.24857 41.3862 8.5102 41.3601C9.60897 41.2422 10.7077 41.072 11.8195 41.0457C12.9837 41.0065 14.0563 41.3862 14.9589 42.1458C15.5867 42.6696 16.1623 43.272 16.7508 43.8613C16.8948 43.9923 16.9863 44.1887 17.1694 44.4637Z"
        fill="white"
      />
      <path
        d="M17.4942 44.0318C17.4027 44.0187 17.3504 44.0187 17.3242 43.9925C16.0161 42.8531 14.7997 41.622 14.4988 39.8146C14.3811 39.0942 14.3942 38.3345 14.4595 37.6011C14.5512 36.6712 14.7735 35.7544 14.9435 34.8376C14.9697 34.7197 15.0482 34.615 15.1136 34.4971C18.3445 36.7629 19.1423 40.5218 17.4942 44.0318Z"
        fill="white"
      />
      <path
        d="M2.98047 34.5352C3.04588 34.4828 3.05895 34.4697 3.07203 34.4697C4.45856 34.509 5.85816 34.509 7.20545 34.8626C8.38269 35.1638 9.33752 35.8317 10.0439 36.8269C10.4101 37.3376 10.7502 37.8745 11.0904 38.3984C11.195 38.5686 11.2473 38.7781 11.3257 38.9746C7.79407 39.7472 4.31467 38.1234 2.98047 34.5352Z"
        fill="white"
      />
      <path
        d="M11.7264 38.6868C11.6741 38.6606 11.5956 38.6475 11.5564 38.6082C10.7716 37.5604 10.0783 36.4602 9.80361 35.1505C9.56814 34.0635 9.76433 33.0288 10.1306 32.0072C10.4314 31.169 10.7846 30.3439 11.1116 29.5188C11.1509 29.4271 11.2163 29.3354 11.2686 29.2568C12.1973 29.8069 13.2437 32.2037 13.3615 33.4872C13.5053 35.2291 12.7074 37.8224 11.7264 38.6868Z"
        fill="white"
      />
      <path
        d="M10.433 23.7295C11.9504 26.3489 10.263 31.1948 7.43766 32.3081C7.38534 32.2426 7.30686 32.1902 7.29378 32.1117C7.03217 31.0508 6.82289 29.9899 6.91445 28.8898C6.99293 27.9075 7.3461 27.0168 7.97396 26.2703C8.69341 25.4059 9.50438 24.607 10.263 23.7819C10.2892 23.7557 10.3415 23.7557 10.433 23.7295Z"
        fill="white"
      />
      <path
        d="M1.11744 25.4355C2.45165 26.0904 3.87742 26.4834 5.00233 27.4526C5.81332 28.1598 6.34962 29.0373 6.61123 30.0719C6.71587 30.5173 6.8336 30.9626 6.91208 31.4079C6.96439 31.7222 6.96439 32.0366 6.99056 32.3508C5.86564 32.4032 3.75969 31.3293 2.76558 30.1898C1.58834 28.8539 1.10437 27.243 1.11744 25.4355Z"
        fill="white"
      />
      <path
        d="M5.82299 25.0195C5.79682 24.9278 5.7445 24.823 5.7445 24.7183C5.71834 23.8014 5.7445 22.8847 5.97995 21.994C6.18924 21.1952 6.58165 20.501 7.14411 19.9117C8.08588 18.9162 9.31546 18.3531 10.4011 17.541C10.8066 18.2352 10.5843 20.1474 9.99562 21.4964C9.31546 23.068 7.4188 24.679 5.82299 25.0195Z"
        fill="white"
      />
      <path
        d="M1.4477 17.1025C2.37642 17.8884 3.29204 18.5825 4.11611 19.3814C5.08406 20.3113 5.55495 21.49 5.54188 22.8521C5.54188 23.3367 5.54188 23.8083 5.51572 24.2929C5.50263 24.5286 5.43723 24.7512 5.39799 24.987C2.62494 24.4369 0.152741 19.6302 1.4477 17.1025Z"
        fill="white"
      />
      <path
        d="M9.93786 6.67955C9.88554 6.61406 9.85938 6.60096 9.85938 6.58786C9.9117 4.36135 10.5134 2.40988 12.6193 1.24423C13.4041 0.812024 14.189 0.406011 14.9738 0C15.2878 0.654857 14.9345 2.43607 14.2805 3.62791C13.4696 5.12098 11.5075 6.50928 9.93786 6.67955Z"
        fill="white"
      />
      <path
        d="M4.15733 9.90234C4.96831 10.9501 5.88395 11.8145 6.4464 12.967C6.74725 13.5826 6.89114 14.2374 6.87805 14.9185C6.83882 15.9008 6.62953 16.8307 6.2502 17.7475C3.778 16.6604 2.58768 12.2467 4.15733 9.90234Z"
        fill="white"
      />
      <path
        d="M12.2323 12.0771C12.1146 15.1939 9.73394 17.6559 6.62081 17.8261C6.60773 17.7737 6.55541 17.7083 6.56849 17.6559C6.8955 15.3904 7.86345 13.5963 10.1656 12.8106C10.715 12.6141 11.2644 12.3784 11.8137 12.1688C11.9445 12.1164 12.0885 12.1164 12.2323 12.0771Z"
        fill="white"
      />
      <path
        d="M14.3683 6.21871C13.9367 9.19139 11.7915 11.2736 8.62604 11.3784C8.59988 11.3391 8.54755 11.2998 8.56067 11.2736C8.79606 10.0688 9.20155 8.92946 10.078 8.02587C10.5488 7.52827 11.1375 7.18778 11.7784 6.96516C12.5371 6.70325 13.2958 6.45443 14.0675 6.21871C14.1329 6.20561 14.2244 6.21871 14.3683 6.21871Z"
        fill="white"
      />
      <path
        d="M6.62813 3.65625C6.77201 3.70865 6.82433 3.70865 6.85049 3.73484C7.42603 4.57306 8.04081 5.39818 8.55096 6.27569C9.07414 7.16629 9.19191 8.16168 8.94332 9.18327C8.7733 9.8774 8.61632 10.5715 8.26316 11.2002C7.55683 10.9514 6.54964 9.62858 6.13107 8.3581C5.59477 6.73409 5.90871 5.20172 6.62813 3.65625Z"
        fill="white"
      />
      <path
        d="M28.0018 47.5071C27.8841 47.9393 27.5833 48.0309 27.23 47.9916C26.3275 47.9 25.3988 47.8607 24.5093 47.6905C22.2334 47.2714 20.1405 46.3809 18.2438 45.0583C18.1261 44.9796 18.0214 44.8749 17.8906 44.7571C17.9561 44.6654 18.0084 44.5999 18.0999 44.4951C18.3746 44.6522 18.6231 44.7963 18.8847 44.9535C20.716 46.0142 22.6912 46.669 24.7841 46.9178C25.6081 47.0095 26.4322 47.0357 27.2562 47.088C27.5571 47.1143 27.871 47.088 28.0018 47.5071Z"
        fill="white"
      />
      <g clipPath="url(#clip0_15502_4034)">
        <path
          d="M42.6563 24.7999L49.7763 29.9999L47.0723 38.3739C46.6354 39.6727 46.6298 41.0779 47.0566 42.3801C47.4833 43.6823 48.3194 44.8117 49.4403 45.5999C50.542 46.4135 51.8771 46.8493 53.2466 46.8425C54.6162 46.8356 55.9468 46.3865 57.0403 45.5619L64.0023 40.4379L70.9663 45.5559C72.0661 46.3648 73.3939 46.8042 74.7591 46.8108C76.1242 46.8175 77.4563 46.3911 78.5639 45.5929C79.6714 44.7948 80.4973 43.666 80.9229 42.3689C81.3485 41.0717 81.3518 39.673 80.9323 38.3739L78.2283 29.9999L85.3483 24.7999C86.4466 23.9969 87.2631 22.8674 87.681 21.5727C88.099 20.278 88.0971 18.8843 87.6757 17.5907C87.2543 16.2971 86.4348 15.1698 85.3344 14.3697C84.234 13.5697 82.9089 13.1378 81.5483 13.1359H72.8023L70.1483 4.86391C69.731 3.56183 68.9109 2.42594 67.8063 1.62004C66.7017 0.814142 65.3697 0.379883 64.0023 0.379883C62.635 0.379883 61.303 0.814142 60.1984 1.62004C59.0938 2.42594 58.2737 3.56183 57.8563 4.86391L55.2023 13.1359H46.4643C45.1038 13.1378 43.7787 13.5697 42.6783 14.3697C41.5779 15.1698 40.7584 16.2971 40.337 17.5907C39.9155 18.8843 39.9137 20.278 40.3317 21.5727C40.7496 22.8674 41.5661 23.9969 42.6643 24.7999H42.6563Z"
          fill="white"
        />
      </g>
      <path
        d="M110.834 44.4637C112.875 45.1447 114.785 45.3804 116.708 44.6339C118.173 44.0577 119.912 42.5386 120.305 41.491C120.03 41.4518 119.755 41.3862 119.494 41.3601C118.395 41.2422 117.296 41.072 116.184 41.0457C115.02 41.0065 113.948 41.3862 113.045 42.1458C112.417 42.6696 111.842 43.272 111.253 43.8613C111.109 43.9923 111.018 44.1887 110.834 44.4637Z"
        fill="white"
      />
      <path
        d="M110.51 44.0318C110.601 44.0187 110.654 44.0187 110.68 43.9925C111.988 42.8531 113.204 41.622 113.505 39.8146C113.623 39.0942 113.61 38.3345 113.544 37.6011C113.453 36.6712 113.23 35.7544 113.06 34.8376C113.034 34.7197 112.956 34.615 112.89 34.4971C109.659 36.7629 108.862 40.5218 110.51 44.0318Z"
        fill="white"
      />
      <path
        d="M125.021 34.5352C124.956 34.4828 124.943 34.4697 124.93 34.4697C123.543 34.509 122.144 34.509 120.797 34.8626C119.619 35.1638 118.664 35.8317 117.958 36.8269C117.592 37.3376 117.252 37.8745 116.912 38.3984C116.807 38.5686 116.755 38.7781 116.676 38.9746C120.208 39.7472 123.687 38.1234 125.021 34.5352Z"
        fill="white"
      />
      <path
        d="M116.278 38.6868C116.33 38.6606 116.408 38.6475 116.448 38.6082C117.232 37.5604 117.926 36.4602 118.2 35.1505C118.436 34.0635 118.24 33.0288 117.873 32.0072C117.572 31.169 117.219 30.3439 116.892 29.5188C116.853 29.4271 116.788 29.3354 116.735 29.2568C115.807 29.8069 114.76 32.2037 114.642 33.4872C114.499 35.2291 115.297 37.8224 116.278 38.6868Z"
        fill="white"
      />
      <path
        d="M117.571 23.7295C116.053 26.3489 117.741 31.1948 120.566 32.3081C120.619 32.2426 120.697 32.1902 120.71 32.1117C120.972 31.0508 121.181 29.9899 121.089 28.8898C121.011 27.9075 120.658 27.0168 120.03 26.2703C119.311 25.4059 118.5 24.607 117.741 23.7819C117.715 23.7557 117.662 23.7557 117.571 23.7295Z"
        fill="white"
      />
      <path
        d="M126.885 25.4355C125.55 26.0904 124.125 26.4834 123 27.4526C122.189 28.1598 121.652 29.0373 121.391 30.0719C121.286 30.5173 121.168 30.9626 121.09 31.4079C121.038 31.7222 121.038 32.0366 121.011 32.3508C122.136 32.4032 124.242 31.3293 125.236 30.1898C126.414 28.8539 126.898 27.243 126.885 25.4355Z"
        fill="white"
      />
      <path
        d="M122.179 25.0195C122.205 24.9278 122.257 24.823 122.257 24.7183C122.284 23.8014 122.257 22.8847 122.022 21.994C121.813 21.1952 121.42 20.501 120.858 19.9117C119.916 18.9162 118.686 18.3531 117.601 17.541C117.195 18.2352 117.418 20.1474 118.006 21.4964C118.686 23.068 120.583 24.679 122.179 25.0195Z"
        fill="white"
      />
      <path
        d="M126.554 17.1025C125.626 17.8884 124.71 18.5825 123.886 19.3814C122.918 20.3113 122.447 21.49 122.46 22.8521C122.46 23.3367 122.46 23.8083 122.486 24.2929C122.499 24.5286 122.565 24.7512 122.604 24.987C125.377 24.4369 127.849 19.6302 126.554 17.1025Z"
        fill="white"
      />
      <path
        d="M118.066 6.67955C118.118 6.61406 118.145 6.60096 118.145 6.58786C118.092 4.36135 117.491 2.40988 115.385 1.24423C114.6 0.812024 113.815 0.406011 113.03 0C112.716 0.654857 113.069 2.43607 113.723 3.62791C114.534 5.12098 116.496 6.50928 118.066 6.67955Z"
        fill="white"
      />
      <path
        d="M123.847 9.90234C123.036 10.9501 122.12 11.8145 121.558 12.967C121.257 13.5826 121.113 14.2374 121.126 14.9185C121.165 15.9008 121.374 16.8307 121.754 17.7475C124.226 16.6604 125.416 12.2467 123.847 9.90234Z"
        fill="white"
      />
      <path
        d="M115.772 12.0771C115.889 15.1939 118.27 17.6559 121.383 17.8261C121.396 17.7737 121.448 17.7083 121.435 17.6559C121.108 15.3904 120.14 13.5963 117.838 12.8106C117.289 12.6141 116.74 12.3784 116.19 12.1688C116.059 12.1164 115.915 12.1164 115.772 12.0771Z"
        fill="white"
      />
      <path
        d="M113.634 6.21871C114.065 9.19139 116.21 11.2736 119.376 11.3784C119.402 11.3391 119.454 11.2998 119.441 11.2736C119.206 10.0688 118.8 8.92946 117.924 8.02587C117.453 7.52827 116.865 7.18778 116.224 6.96516C115.465 6.70325 114.706 6.45443 113.934 6.21871C113.869 6.20561 113.778 6.21871 113.634 6.21871Z"
        fill="white"
      />
      <path
        d="M121.376 3.65625C121.232 3.70865 121.18 3.70865 121.153 3.73484C120.578 4.57306 119.963 5.39818 119.453 6.27569C118.93 7.16629 118.812 8.16168 119.061 9.18327C119.231 9.8774 119.388 10.5715 119.741 11.2002C120.447 10.9514 121.454 9.62858 121.873 8.3581C122.409 6.73409 122.095 5.20172 121.376 3.65625Z"
        fill="white"
      />
      <path
        d="M100.002 47.5071C100.12 47.9393 100.421 48.0309 100.774 47.9916C101.676 47.9 102.605 47.8607 103.495 47.6905C105.771 47.2714 107.863 46.3809 109.76 45.0583C109.878 44.9796 109.982 44.8749 110.113 44.7571C110.048 44.6654 109.996 44.5999 109.904 44.4951C109.629 44.6522 109.381 44.7963 109.119 44.9535C107.288 46.0142 105.313 46.669 103.22 46.9178C102.396 47.0095 101.572 47.0357 100.748 47.088C100.447 47.1143 100.133 47.088 100.002 47.5071Z"
        fill="white"
      />
      <defs>
        <clipPath id="clip0_15502_4034">
          <rect
            width="48"
            height="48"
            fill="white"
            transform="translate(40.002)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default RatingIllustration
